import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

import { Icon } from '../icon'

import styles from './cart-urgency.module.scss'
import ClockIcon from './icons/clock_v2.inline.svg'

interface CartUrgencyProps {
  className?: string
}

export const useCartUrgencyExperiment = (): boolean => {
  const { experimentBucket: cartUrgencyBucket, init: initCartUrgency } = useStatsigExperiment(
    STATSIG_EXPERIMENTS.CART_URGENCY,
  )
  const isCartUrgencyEnabled =
    initCartUrgency && cartUrgencyBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CART_URGENCY].buckets?.Show

  return isCartUrgencyEnabled
}

export const CartUrgency = ({ className }: CartUrgencyProps) => {
  const { t } = useTranslation('common')

  return (
    <div className={classNames(styles.cartUrgencyMessage, className)}>
      <Icon iconSvg={ClockIcon} className={styles.clockIcon} /> {t('selling_fast_miss_out')}
    </div>
  )
}
